import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApplicationHttpClient } from '@app/core/http';
import { AuthenticationService } from '@app/core/services/authentication.service';
// import { City } from '@app/core/models';

@Injectable({ providedIn: 'root' })
export class ExternalService {

  constructor(
    private http: ApplicationHttpClient,
    private authService: AuthenticationService
  ) {
  }

  public getEmployeeByIsurranceCode(code: string): Observable<any> {
    return this.http.get(`/api/app/external-sevice/isurrance-code?isurranceCode=${code}`);
  }

  public getC12OfYear(year: string, insuranceCompanyCode: string): Observable<any> {
    return this.http.get(`/api/app/external-sevice/c12?year=${year}&insuranceCompanyCode=${insuranceCompanyCode}`);
  }

  public downloadC12(year: string, month: string, insuranceCompanyCode: string) {
    return this.http.getFile(`/api/app/external-sevice/dowload-c12?month=${ month }&year=${ year }&insuranceCompanyCode=${insuranceCompanyCode}`, {
      headers: {
        token: this.authService.getCredentialToken()
      }
    });
  }

  public getIsurranceCode(body, options: any = {}) {
    options.displayLoading = true;
    return this.http.post('/api/app/external-sevice/isurrance-code', body, options);
  }

  public getResultReceptionDocment(id: string): Observable<any> {
    return this.http.get(`/api/app/external-sevice/result-declaration/${id}`);
  }

  public getResultReceptionDocmentDocNo(documentNo: string): Observable<any> {
    return this.http.get(`/api/app/external-sevice/result-declaration-no?docummentNo=${documentNo}`);
  }

  public getProcessDeclaration(declarationFileId: string): Observable<any> {
    return this.http.get(`/api/app/external-sevice/process-document/${declarationFileId}`);
  }

  public getProcessDeclarationDocNo(docummentNo: string): Observable<any> {
    return this.http.get(`/api/app/external-sevice/process-document-no?docummentNo=${docummentNo}`);
  }

  public getProcessDeclarationOfCompany(declarationFileId: string): Observable<any> {
    return this.http.get(`/api/app/external-sevice/result-declaration-of-company/${declarationFileId}`);
  }

}
